import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addMonths,
  subMonths,
  isToday,
  isSameDay,
  parseISO
} from 'date-fns';

export const toJsDate = (date) => {
  if (!date) return null;
  if (date instanceof Date) return date;
  if (date.toDate) return date.toDate();
  return new Date(date);
};

export const formatDate = (date, pattern = 'MMM d, yyyy') => {
  if (!date) return '';
  return format(toJsDate(date), pattern);
};

export const getMonthRange = (date) => {
  return {
    start: startOfWeek(startOfMonth(date)),
    end: endOfWeek(endOfMonth(date))
  };
};

export const getWeekRange = (date) => {
  return {
    start: startOfWeek(date),
    end: endOfWeek(date)
  };
};

export { format, startOfMonth, endOfMonth, addMonths, subMonths, isToday, isSameDay, parseISO };
